export default class NumberUtils {
  static sortAsc(a: number | undefined, b: number | undefined) {
    return (a !== null && a !== undefined ? a : Infinity) - (b !== null && b !== undefined ? b : Infinity);
  }
  static parseInt(value: string | null) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const number = Number.parseInt(value!);
    return number ? number : 0;
  }
}
